import React, { useRef, useState, useEffect } from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { PhoneForwarded } from '@material-ui/icons';
import Maps from './Maps';
import {
  Card,
  CardContent,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Grid,
  Box,
  Dialog,
  DialogContent,
} from '@material-ui/core';
import { getContactUsInfo } from '../../../services';

const Fade = require('react-reveal/Fade');

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    rootCard: {
      boxShadow: 'none',
    },
    formControl: {
      marginTop: 16,
      width: '100%',
      [theme.breakpoints.up(2550)]: {
        height: 70,
      },
    },
    title: {
      marginBottom: '2rem',
      [theme.breakpoints.up(2550)]: {
        fontSize: '2.8rem',
      },
    },
    contactBox: {
      width: '100%',
      backgroundColor: 'red',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 16,
      padding: 16,
    },
    [theme.breakpoints.down('sm')]: {
      rootCard: {
        display: 'none',
      },
    },
  })
);

const CekTarif = ({ isId, listAsalTujuan, openModal, onCloseModal }: any) => {
  const childRef: any = useRef();
  const classes = useStyles();
  const [asalTujuanState, setAsalTujuanState] = React.useState({
    asal: '',
    tujuan: '',
    golongan: '',
  });
  const [tarifState, setTarifState] = React.useState<any>({
    tarif: null,
    keterangan: '',
  });
  const [contactState, setContactState] = useState([]);

  const handleChangeAsalTujuan = (
    e: React.ChangeEvent<{ value: unknown }>,
    id: string
  ) => {
    setAsalTujuanState({ ...asalTujuanState, [id]: e.target.value });
  };

  const handleCekTarif = async (e: any) => {
    e.preventDefault();
    childRef.current.handleReset();

    const { asal, tujuan, golongan } = asalTujuanState;
    try {
      const res = await fetch(
        `${process.env.REACT_APP_URL}/api/jlp/beranda/tarif?ruas=JTD&asal=${asal}&tujuan=${tujuan}&golongan=${golongan}`
      );
      const resJson = await res.json();
      childRef.current.handleMarker();
      childRef.current.handlePolyline();
      setTarifState({
        tarif: Intl.NumberFormat('id-Id').format(+resJson.data.tarif),
        keterangan: resJson.data.keterangan,
      });
    } catch (err: any) {
      console.log(err.message);
    }
  };

  const fetchContact = async () => {
    try {
      const res = await getContactUsInfo();
      setContactState(res.data.tlpMaps);
    } catch (err: any) {
      console.log(err.message);
    }
  };

  useEffect(() => {
    fetchContact();
  }, []);

  return (
    <>
      <Grid item xs={12} md={4}>
        <Fade right>
          <Card className={classes.rootCard}>
            <CardContent>
              <form onSubmit={handleCekTarif}>
                <Typography
                  align='center'
                  color='primary'
                  variant='h4'
                  className={classes.title}
                >
                  {isId ? 'Tarif Tol' : 'Toll Rates'}
                </Typography>
                <FormControl variant='outlined' className={classes.formControl}>
                  <InputLabel id='gerbang-masuk'>
                    {isId ? 'Gerbang Masuk' : 'Entrance Gate'}
                  </InputLabel>
                  <Select
                    labelId='gerbang-masuk'
                    id='gerbang-masuk'
                    value={asalTujuanState.asal}
                    onChange={(e) => handleChangeAsalTujuan(e, 'asal')}
                    label={isId ? 'Gerbang Masuk' : 'Entrance Gate'}
                    required
                  >
                    {listAsalTujuan.asal?.map((asal: string, i: number) => (
                      <MenuItem key={i} value={asal}>
                        {asal}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl variant='outlined' className={classes.formControl}>
                  <InputLabel id='gerbang-keluar'>
                    {isId ? 'Gerbang Keluar' : 'Exit Gate'}
                  </InputLabel>
                  <Select
                    labelId='gerbang-keluar'
                    id='gerbang-keluar'
                    value={asalTujuanState.tujuan}
                    onChange={(e) => handleChangeAsalTujuan(e, 'tujuan')}
                    label={isId ? 'Gerbang Keluar' : 'Exit Gate'}
                    disabled={!asalTujuanState.asal}
                    required
                  >
                    {listAsalTujuan.tujuan
                      ?.filter((tujuan: string) => {
                        let moreFilter;
                        if (tujuan === 'CAKUNG') {
                          moreFilter = 'BEKASI RAYA';
                        }
                        if (tujuan === 'BEKASI RAYA') {
                          moreFilter = 'CAKUNG';
                        }
                        return (
                          asalTujuanState.asal !== tujuan &&
                          asalTujuanState.asal !== moreFilter
                        );
                      })
                      .map((tujuan: string, i: number) => (
                        <MenuItem key={i} value={tujuan}>
                          {tujuan}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
                <FormControl variant='outlined' className={classes.formControl}>
                  <InputLabel id='gol'>
                    {isId ? 'Gologan Kendaraan' : 'Vehicle Class'}
                  </InputLabel>
                  <Select
                    labelId='gol'
                    id='gol'
                    value={asalTujuanState.golongan}
                    onChange={(e) => handleChangeAsalTujuan(e, 'golongan')}
                    label={isId ? 'Gologan Kendaraan' : 'Vehicle Class'}
                    required
                  >
                    {listAsalTujuan.golongan
                      ?.sort()
                      .map((gol: string, i: number) => (
                        <MenuItem key={i} value={gol}>
                          {gol}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
                <div
                  style={{
                    marginTop: '2rem',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                  }}
                >
                  <Button variant='contained' color='primary' type='submit'>
                    {isId ? 'Cek Tarif' : 'Check Rates'}
                  </Button>
                  {tarifState.tarif && (
                    <div style={{ width: 170 }}>
                      <Typography
                        style={{ color: 'green' }}
                        variant='h5'
                        align='right'
                      >
                        Rp {tarifState.tarif}
                      </Typography>
                    </div>
                  )}
                </div>
              </form>
            </CardContent>
          </Card>
        </Fade>
      </Grid>
      <Grid item xs={12} md={4}>
        <Fade bottom>
          <Maps
            ref={childRef}
            asal={asalTujuanState.asal}
            tujuan={asalTujuanState.tujuan}
          />
        </Fade>
        <Fade top>
          <Box className={classes.contactBox}>
            <PhoneForwarded style={{ color: '#fff', fontSize: 50 }} />
            <div>
              <Typography style={{ color: '#fff' }} gutterBottom>
                Layanan Pusat Bantuan
              </Typography>
              {contactState.map((tlp) => (
                <Typography variant='h5' style={{ color: '#fff' }}>
                  {tlp}
                </Typography>
              ))}
            </div>
          </Box>
        </Fade>
      </Grid>
      <Dialog
        fullWidth
        onClose={onCloseModal}
        aria-labelledby='simple-dialog'
        open={openModal}
      >
        <DialogContent style={{ paddingBottom: 32 }}>
          <form onSubmit={handleCekTarif}>
            <Typography
              align='center'
              color='primary'
              variant='h5'
              gutterBottom
            >
              {isId ? 'Tarif Tol' : 'Toll Rates'}
            </Typography>
            <FormControl variant='outlined' className={classes.formControl}>
              <InputLabel id='gerbang-masuk'>
                {isId ? 'Gerbang Masuk' : 'Entrance Gate'}
              </InputLabel>
              <Select
                labelId='gerbang-masuk'
                id='gerbang-masuk'
                value={asalTujuanState.asal}
                onChange={(e) => handleChangeAsalTujuan(e, 'asal')}
                label={isId ? 'Gerbang Masuk' : 'Entrance Gate'}
                required
              >
                {listAsalTujuan.asal?.map((asal: string, i: number) => (
                  <MenuItem key={i} value={asal}>
                    {asal}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl variant='outlined' className={classes.formControl}>
              <InputLabel id='gerbang-keluar'>
                {isId ? 'Gerbang Keluar' : 'Exit Gate'}
              </InputLabel>
              <Select
                labelId='gerbang-keluar'
                id='gerbang-keluar'
                value={asalTujuanState.tujuan}
                onChange={(e) => handleChangeAsalTujuan(e, 'tujuan')}
                label={isId ? 'Gerbang Keluar' : 'Exit Gate'}
                disabled={!asalTujuanState.asal}
                required
              >
                {listAsalTujuan.tujuan
                  ?.filter((tujuan: string) => {
                    let moreFilter;
                    if (tujuan === 'CAKUNG') {
                      moreFilter = 'BEKASI RAYA';
                    }
                    if (tujuan === 'BEKASI RAYA') {
                      moreFilter = 'CAKUNG';
                    }
                    return (
                      asalTujuanState.asal !== tujuan &&
                      asalTujuanState.asal !== moreFilter
                    );
                  })
                  .map((tujuan: string, i: number) => (
                    <MenuItem key={i} value={tujuan}>
                      {tujuan}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
            <FormControl variant='outlined' className={classes.formControl}>
              <InputLabel id='gol'>
                {isId ? 'Gologan Kendaraan' : 'Vehicle Class'}
              </InputLabel>
              <Select
                labelId='gol'
                id='gol'
                value={asalTujuanState.golongan}
                onChange={(e) => handleChangeAsalTujuan(e, 'golongan')}
                label={isId ? 'Gologan Kendaraan' : 'Vehicle Class'}
                required
              >
                {listAsalTujuan.golongan
                  ?.sort()
                  .map((gol: string, i: number) => (
                    <MenuItem key={i} value={gol}>
                      {gol}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
            <div
              style={{
                marginTop: '2rem',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
              }}
            >
              <Button
                variant='contained'
                color='primary'
                type='submit'
                style={{ width: 140 }}
              >
                {isId ? 'Cek Tarif' : 'Check Rates'}
              </Button>
              {tarifState.tarif && (
                <div style={{ width: 170 }}>
                  <Typography
                    style={{ color: 'green' }}
                    variant='h5'
                    align='right'
                  >
                    Rp {tarifState.tarif}
                  </Typography>
                  <Typography align='right' color='textSecondary'>
                    {tarifState.keterangan}
                  </Typography>
                </div>
              )}
            </div>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CekTarif;
